import { gsap } from "gsap";

export default function() {

  let top01;
  let set01;

  if (window.matchMedia("(min-width: 770px)").matches) {
    top01 = -300;
    set01 = 20;
  } else {
    top01 = "-40vw";
    set01 = "1.312vw";
  }

  gsap.set(".js-fva-logo", { top: top01, opacity: 0 });
  gsap.to(".js-fva-logo", {
    delay: 5,
    opacity: 1,
    duration: 1,
    top: set01,
    ease: "bounce.out"
  });
}
